import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { GenderData } from '@core/interfaces/analytics.interface';
import {
  ApexChart,
  ApexDataLabels,
  ApexLegend,
  ApexNonAxisChartSeries,
  ApexPlotOptions,
  ApexResponsive,
  ApexTooltip,
} from 'ng-apexcharts';

@Component({
  selector: 'app-funnel-chart',
  template: `
    <div *ngIf="chartSeries.length > 0; else noData">
      <apx-chart
        [series]="chartSeries"
        [chart]="chart"
        [labels]="chartLabels"
        [colors]="colors"
        [legend]="legend"
        [plotOptions]="plotOptions"
        [dataLabels]="dataLabels"
        [tooltip]="tooltip"
        [responsive]="responsive"
      ></apx-chart>
    </div>
    <ng-template #noData>
      <div class="no-data-msg">
        <i class="ri-pie-chart-2-line"></i>
        <span>Sin datos</span>
      </div>
    </ng-template>
  `,
  styles: [
    `
      .no-data-msg {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 260px;
        color: #ccc;
        gap: 10px;
      }
      .no-data-msg i {
        font-size: 48px;
      }
      .no-data-msg span {
        font-size: 14px;
      }
    `,
  ],
})
export class FunnelChartComponent implements OnChanges {
  @Input() genderData: GenderData[] = [];

  chartSeries: ApexNonAxisChartSeries = [];
  chartLabels: string[] = [];
  colors = ['#4361ee', '#f28e2b', '#76b7b2', '#e15759'];

  chart: ApexChart = {
    type: 'donut',
    height: 280,
    toolbar: { show: false },
    fontFamily: 'inherit',
  };

  plotOptions: ApexPlotOptions = {
    pie: {
      donut: {
        size: '65%',
        labels: {
          show: true,
          total: {
            show: true,
            label: 'Total',
            formatter: (w: any) =>
              w.globals.seriesTotals
                .reduce((a: number, b: number) => a + b, 0)
                .toLocaleString('es'),
          },
          value: {
            formatter: (val: string) => Number(val).toLocaleString('es'),
          },
        },
      },
    },
  };

  dataLabels: ApexDataLabels = { enabled: false };
  legend: ApexLegend = { position: 'bottom', horizontalAlign: 'center', fontSize: '13px' };
  tooltip: ApexTooltip = {
    y: { formatter: (val: number) => val.toLocaleString('es') + ' participantes' },
  };
  responsive: ApexResponsive[] = [
    { breakpoint: 480, options: { chart: { height: 220 } } },
  ];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['genderData']?.currentValue) {
      this.chartLabels = this.genderData.map((d) => d._id || 'Sin especificar');
      this.chartSeries = this.genderData.map((d) => d.count);
    }
  }
}
